import { MutationTree } from "vuex";
import { ControllerState, Controller } from "./model";

const mutations: MutationTree<ControllerState> = {
  setControllers(state, controllers: Controller[]) {
    state.controllers = controllers
  },
  setController(state, controller: Controller) {
    state.controller = controller
  },
  addController(state, controller: Controller) {
    state.controllers.push(controller)
  },
  updateController(state, controller: Controller) {
    const c = state.controllers.find(c => c.id === controller.id);
    Object.assign(c, controller);
  },
  deleteController(state, id: string) {
    state.controllers = state.controllers.filter(controller => controller.id !== id)
  }
}

export default mutations;
